var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowToBottom = function SvgArrowToBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.766,6.121C9.902,5.984 9.902,5.766 9.766,5.656L9.219,5.109C9.109,4.973 8.891,4.973 8.754,5.109L6.184,7.762L6.184,0.953C6.184,0.789 6.047,0.625 5.855,0.625L5.09,0.625C4.926,0.625 4.762,0.789 4.762,0.953L4.762,7.762L2.219,5.109C2.082,4.973 1.863,4.973 1.754,5.109L1.207,5.656C1.07,5.766 1.07,5.984 1.207,6.121L5.254,10.168C5.391,10.305 5.582,10.305 5.719,10.168L9.766,6.121ZM10.422,11.453L0.578,11.453C0.387,11.453 0.25,11.617 0.25,11.781L0.25,12.547C0.25,12.738 0.387,12.875 0.578,12.875L10.422,12.875C10.586,12.875 10.75,12.738 10.75,12.547L10.75,11.781C10.75,11.617 10.586,11.453 10.422,11.453Z",
    transform: "matrix(1,0,0,1,0,1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowToBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-to-bottom.15fbd099.svg";
export { ForwardRef as ReactComponent };